import Navbar from "./Components/Navbar";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Privacy from "./Components/Privacy";
import About from "./Components/About";
import Features from "./Components/Features";
import Download from "./Components/Download";
import Screenshots from "./Components/Screenshots";
import "./App.css";

function App() {
	return (
		<div>
			<Navbar />
			<Header />
			<About />
			<Features />
			<Screenshots />
			<Download />
			<Privacy />
			<Footer />
		</div>
	);
}

export default App;
